import { getImage } from './get-image-dimensions';
import { seededRandom } from './seeded-random';

const guestAvatarSize = 196;
const guestAvatarPadding = 26;

export const animals = [
  'Bird',
  'Butterfly',
  'Cat',
  'Chicken',
  'Cow',
  'Crab',
  'Croco',
  'Dog',
  'Duck',
  'Elephant',
  'Fish',
  'Fly',
  'Fox',
  'Jellyfish',
  'Koala',
  'Octopus',
  'Owl',
  'Spider',
  'Turtle',
  'Whale',
];

const gradientColors = [
  '25AC66',
  '3B68D6',
  '518CC7',
  '5AEA74',
  '5CB7C4',
  '7D84C3',
  '8244AC',
  '826EDF',
  '8F7570',
  '9ECA39',
  'A747D2',
  'ADAAD1',
  'AF6A9C',
  'B35C7D',
  'BB41D0',
  'C975A4',
  'DBB240',
  'DF5FAA',
  'DF948E',
  'E56C79',
  'EBA77D',
  'F073B3',
  'F97B70',
  'FF7379',
  'FF9E79',
];

export const getUserColor = (seed: string) => {
  const backgroundIndex = Math.floor(seededRandom(seed) * gradientColors.length);
  return gradientColors[backgroundIndex];
};

export const calcInitials = (firstName: string, lastName: string, email: string) => {
  if (!firstName && !lastName) {
    if (email) return email[0];
    return 'U';
  }
  if (lastName) return firstName[0] + lastName[0];
  return firstName[0] + (firstName[1] || '');
};

const getBackgroundImage = async (seed: string) => {
  const backgroundImagePath = `/assets/guest-avatar-parts/backgrounds/${getUserColor(seed)}.png`;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const backgroundImage = await getImage(backgroundImagePath);

  canvas.width = guestAvatarSize;
  canvas.height = guestAvatarSize;

  ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height);

  return { canvas, ctx };
};

export const getDefaultUserAvatar = async (seed: string, initials: string) => {
  const { canvas, ctx } = await getBackgroundImage(seed);

  ctx.fillStyle = 'white';
  ctx.font = `${Math.round(guestAvatarSize / 5) * 2}px AkkuratLL`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  const measurement = ctx.measureText(initials.toUpperCase());

  const offsetY = measurement.actualBoundingBoxAscent - measurement.actualBoundingBoxDescent;
  const offsetX = measurement.actualBoundingBoxRight - measurement.actualBoundingBoxLeft;

  ctx.fillText(initials.toUpperCase(), guestAvatarSize / 2 + offsetX / 2, guestAvatarSize / 2 + offsetY / 2);

  return canvas.toDataURL('png');
};

export const getAnonymousGuestAvatar = async (seed: string) => {
  const animalIndex = Math.floor(seededRandom(seed + 'a') * animals.length);
  const animalImagePath = `/assets/guest-avatar-parts/foregrounds/${animals[animalIndex]}.svg`;

  const [{ canvas, ctx }, animalImage] = await Promise.all([getBackgroundImage(seed), getImage(animalImagePath)]);

  const animalSize = canvas.width - guestAvatarPadding * 2;
  ctx.drawImage(animalImage, guestAvatarPadding, guestAvatarPadding, animalSize, animalSize);

  return canvas.toDataURL('png');
};
